import React from 'react'
import s from './styles/SearchLine.module.scss'
import SearchIcon from 'shared/components/SearchIcon/SearchIcon'
import { ReactComponent as CrossIcon } from 'assets/icons/cross.svg'

const SearchLine = ({
	className,
	onSearchChange,
	placeholder = 'Search student',
	value,
	onFocus,
	showClear = false,
	onClear,
}) => {
	return (
		<div className={`${s.search} ${showClear ? s.search_withClear : ''} ${className || ''}`}>
			<span className={s.search__icon} aria-hidden="true">
				<SearchIcon />
			</span>
			<input
				className={s.search__input}
				placeholder={placeholder}
				onChange={onSearchChange}
				onFocus={onFocus}
				value={value ?? ''}
				aria-label={placeholder}
			/>
			{showClear ? (
				<button
					type="button"
					className={s.search__clear}
					onClick={onClear}
					aria-label="Close search"
				>
					<CrossIcon />
				</button>
			) : null}
		</div>
	)
}

export default SearchLine
